const marker = [
  {
    id: 1,
    name: "lamp-",
    coordinates: [10.989521, -74.7887],
    status:true
  },
  
];
export default marker;
